const outline = {
  outlineColor: '-webkit-focus-ring-color',
  outlineStyle: 'auto',
  outlineWidth: '5px',
  outline: '5px auto -webkit-focus-ring-color',
  outlineOffset: '-2px'
};

export default outline;
